<template>
  <div>
    <div v-if="showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Larval Site Master</h1>
          <div class="pull-right btn-group">
            <button
              class="pointer btn btn-lg btn-primary"
              v-on:click="form.showEdit({})"
            >
              Create New
            </button>
          </div>
        </div>
      </div>

      <div class="panel">
        <search-fields
          :form="form"
          :fields="searchFieldsList"
          :showDraggableHint="true"
        ></search-fields>

        <loading :working="form.working()"></loading>

        <div class="panel-body" v-if="!form.working()">
          <div class="col-xs-12 table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Active</th>
                  <th>Site Name/Id</th>
                  <th>Landowner Address</th>
                  <th>Contact</th>
                  <th>Found</th>
                  <th>Zone/Route Order</th>
                  <th>Schedule</th>
                  <th width="120"></th>
                </tr>
              </thead>

              <draggable
                v-model="form.list"
                @end="listUpdated"
                :element="'tbody'"
                :options="{ handle: '.handle' }"
              >
                <tr v-for="item in form.list" :key="item.id">
                  <td>
                    <i
                      class="fa"
                      :class="{
                        'fa-check-square-o': item.attributes.isActive,
                        'fa-square-o': !item.attributes.isActive,
                      }"
                    ></i>
                  </td>
                  <td>{{ siteName(item.attributes.siteId) }}</td>
                  <td>
                    <table>
                      <tr>
                        <td
                          class="pointer, nowrap"
                          v-if="
                            item.attributes.coordinates == null ||
                              item.attributes.coordinates.length == 0
                          "
                        >
                          <i class="fa fa-map" />(no coordinates)
                        </td>
                        <td
                          class="pointer, nowrap"
                          v-if="
                            item.attributes.coordinates != null &&
                              item.attributes.coordinates.length > 0
                          "
                          v-on:click="
                            showMap(
                              `${item.attributes.coordinates[0].lat}, ${item.attributes.coordinates[0].lon}`
                            )
                          "
                        >
                          <i class="fa fa-map" />
                          {{ item.attributes.coordinates[0].lat }},
                          {{ item.attributes.coordinates[0].lon }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          class="pointer"
                          v-on:click="showMap(`${item.attributes.address}`)"
                        >
                          <i class="fa fa-map" /> {{ item.attributes.address }}
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td>
                    {{ item.attributes.contactDate | date }}<br />
                    {{ item.attributes.contactPerson }}<br />
                    {{ item.attributes.phoneNumber }}
                  </td>
                  <td>
                    {{ item.attributes.foundDate | date }}<br />
                    {{ item.attributes.foundBy }}
                  </td>
                  <td>
                    {{ zoneName(item.attributes.zoneId) }} -
                    {{ item.attributes.routeOrder }}
                  </td>
                  <td>
                    Starts:
                    <span v-if="item.attributes.scheduleStart">{{
                      item.attributes.scheduleStart | date
                    }}</span
                    ><br />
                    every {{ item.attributes.scheduleFrequency }} days
                  </td>

                  <td class="nowrap">
                    <i
                      v-if="isFilteredByOneZone"
                      class="fa fa-bars handle"
                      style="margin-right: 10px; color: #3287B2"
                      title="Reorder larvicide route"
                    />
                    <router-link
                      :to="{
                        name: 'data-larval-site-details',
                        params: { id: item.id },
                      }"
                      ><i
                        class="fa fa-ellipsis-h"
                        style="margin-right: 10px;"
                      ></i
                    ></router-link>
                    <router-link
                      :to="{
                        name: 'data-larvicide-with',
                        params: { type: 'ls', id: item.id },
                      }"
                      ><i
                        class="fa fa-file-o mr-10"
                        title="Add larvicide data"
                      ></i
                    ></router-link>
                    <a
                      class="pointer text-danger"
                      v-on:click="form.destroy(item.id)"
                      ><i class="fa fa-times"></i
                    ></a>
                  </td>
                </tr>
              </draggable>

              <pager :form="form"></pager>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!showList">
      <div class="row">
        <div class="col-sm-12">
          <h1 class="page-title pull-left">Associate larval sites</h1>
          <div class="pull-right">
            <div class="btn-group">
              <button
                class="pointer btn btn-lg"
                v-on:click="showList = !showList"
              >
                <i class="fa fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="panel">
        <div class="panel-body">
          <table class="table table-striped">
            <thead>
              <th>Name</th>
              <th>City</th>
              <th>State</th>
              <th>Location</th>
              <th>Trap Site</th>
            </thead>
            <tbody>
              <tr v-for="(zone, index) in shapeFile">
                <td>{{ zone.properties.Name }}</td>
                <td>{{ zone.properties.City }}</td>
                <td>{{ zone.properties.State }}</td>
                <td
                  class="pointer"
                  v-on:click="
                    showMap({
                      lat: zone.geometry.coordinates[1],
                      lon: zone.geometry.coordinates[0],
                    })
                  "
                >
                  <i class="fa fa-map"></i> 1 point
                </td>
                <td>
                  <div class="input-group">
                    <span class="input-group-addon">Action</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['id']"
                    >
                      <option value="ignore">Ignore</option>
                      <option value="new">Create New</option>
                      <option v-for="item in form.list" v-bind:value="item.id"
                        >{{ siteName(item.attributes.siteId) }} -
                        {{ item.attributes.address }}</option
                      >
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Active</span>
                    <input
                      type="checkbox"
                      id="isActive"
                      v-model="siteAssociations[index]['isActive']"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Site</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['siteId']"
                    >
                      <option></option>
                      <option v-for="item in sites" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">County</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['countyId']"
                    >
                      <option></option>
                      <option v-for="item in counties" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Route</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['routeId']"
                    >
                      <option></option>
                      <option v-for="item in routes" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Permission</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['permission']"
                    >
                      <option value="granted">Granted</option>
                      <option value="denied">Denied</option>
                      <option value="unknown">Unknown</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Unincorporated</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['unincorporated']"
                    >
                      <option value="unincorporated">unincorporated</option>
                      <option value="in city">In city</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Habitat</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['habitatId']"
                    >
                      <option></option>
                      <option v-for="item in habitats" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Water Of US</span>
                    <input
                      type="checkbox"
                      id="waterOfUs"
                      v-model="siteAssociations[index]['waterOfUs']"
                    />
                  </div>
                  <div class="input-group">
                    <span class="input-group-addon">Water</span>
                    <select
                      class="form-control"
                      v-model="siteAssociations[index]['waterId']"
                    >
                      <option></option>
                      <option v-for="item in waters" v-bind:value="item.id">{{
                        item.attributes.name
                      }}</option>
                    </select>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="7">
                  <button
                    class="btn btn-primary pull-right"
                    v-on:click="createTraps()"
                  >
                    Save
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>

    <google-map ref="gmap"></google-map>
    <input
      type="file"
      id="shape"
      v-on:change="readShape()"
      accept=".zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed"
    />
  </div>
</template>

<script>
import LarvalSitesService from '@/services/LarvalSitesService';
import Form from '@/utils/form';
import loader from '@/utils/loader';
import siteForm from '@/components/forms/larval_site';
import pager from '@/components/forms/pager';
import googleMap from '@/components/googleMap';
import store from '@/store';
import loading from '@/components/loading';
import searchFields from '@/components/search_fields';
import draggable from 'vuedraggable';

export default {
  name: 'larval_sites',

  components: {
    pager,
    siteForm,
    googleMap,
    loading,
    searchFields,
    draggable,
  },

  props: ['id', 'type'],

  data() {
    const { $props, $router } = this;
    const successCallback = () => {
      if ($props.type == 's') {
        $router.push({
          name: 'data-larvicide-with',
          params: {
            ...$props,
          },
        });
      }
    };
    return {
      showList: true,
      shapeFile: null,
      siteAssociations: [],
      searchFieldsList: {
        site: 'Site',
        location: 'Location',
        zone: 'Zone',
        route: 'Route',
      },
      form: new Form(LarvalSitesService, {
        isActive: null,
        address: null,
        city: null,
        stateId: null,
        zip: null,
        contactPerson: null,
        contactDate: null,
        phoneNumber: null,
        foundDate: null,
        foundBy: null,
        scheduleStart: null,
        scheduleFrequency: null,
        successCallback,
      }),
    };
  },

  methods: {
    listUpdated: function(event) {
      const item = this.form.list[event.newIndex];

      if (
        item.attributes.zoneId == null ||
        item.attributes.routeOrder == null
      ) {
        return true;
      }

      var madeRouteOrderChange = false;

      if (event.newIndex < event.oldIndex) {
        let i;
        for (i = event.newIndex + 1; i <= event.oldIndex; i++) {
          let comparisonItem = this.form.list[i];
          if (
            comparisonItem.attributes.zoneId != null &&
            comparisonItem.attributes.zoneId == item.attributes.zoneId &&
            comparisonItem.attributes.routeOrder != null
          ) {
            item.attributes.routeOrder = comparisonItem.attributes.routeOrder;
            madeRouteOrderChange = true;
            break;
          }
        }
      } else {
        let i;
        for (i = event.newIndex - 1; i >= event.oldIndex; i--) {
          let comparisonItem = this.form.list[i];
          if (
            comparisonItem.attributes.zoneId != null &&
            comparisonItem.attributes.zoneId == item.attributes.zoneId &&
            comparisonItem.attributes.routeOrder != null
          ) {
            item.attributes.routeOrder = comparisonItem.attributes.routeOrder;
            madeRouteOrderChange = true;
            break;
          }
        }
      }

      if (madeRouteOrderChange) {
        this.form.data = item.attributes;
        this.form.data.id = item.id;

        this.form.onSubmit({ updateStore: true, updateList: true }).then(() => {
          /*
           * We only actually updated the route_order of the record we submitted.
           * The backend is going to reorder everything else so there are no collisions,
           * but we don't have a good way to get all those changes here at the moment without
           * causing all of the data to reload and throwing away things like search context.
           *
           * SO WE ARE DUPLICATING THE BACKEND'S RENUMBERING LOGIC HERE.
           *
           * We are taking advantage of the fact that we have these items ordered in the list
           * according to route_order already, so we can use list indices to help ourselves.
           */
          const pageSize = this.form.service.pageSize();
          let i;
          for (i = 0; i < this.form.list.length; i++) {
            this.form.list[i].attributes.routeOrder =
              pageSize * (this.currentPageNumber - 1) + i + 1;
          }
        });
      }

      return true;
    },
    stateName(id) {
      return this.$store.getters.stateNameById(id);
    },
    zoneName(id) {
      return this.$store.getters.zoneNameById(id);
    },
    siteName(id) {
      return this.$store.getters.siteNameById(id);
    },
    routeName(id) {
      return this.$store.getters.routeNameById(id);
    },
    showMap(coordinates) {
      this.$refs.gmap.showMap(coordinates);
    },
    getShape() {
      document.querySelector('#shape').click();
    },
    readShape() {
      let files = document.querySelector('#shape').files;
      if (!files.length) {
        return;
      }

      var that = this;
      let fileReader = new FileReader();
      fileReader.onloadend = () => {
        document.querySelector('#shape').value = null;

        LarvalSitesService.shape({ shape: fileReader.result }).then((data) => {
          that.shapeFile = data;
          _.forEach(data, (item, index) => {
            that.siteAssociations[index] = {
              id: 'ignore',
              isActive: true,
              coordinates: [
                {
                  lat: item.geometry.coordinates[1],
                  lon: item.geometry.coordinates[0],
                },
              ],
              siteId: true,
              countyId: null,
              routeId: null,
              permission: null,
              municipalityId: null,
              location: null,
              unincorporated: null,
              waterId: null,
              habitatId: null,
              waterOfUs: null,
            };
          });

          that.showList = false;
        });
      };
      fileReader.readAsDataURL(files[0]);
    },
    createTraps() {
      LarvalSitesService.createShapes({ traps: this.siteAssociations }).then(
        () => {
          this.form.getList();
          this.showList = true;
        }
      );
    },
  },

  computed: {
    currentPageNumber() {
      return this.form.nextPageNumber == 1 ? 1 : this.form.nextPageNumber - 1;
    },
    isFilteredByOneZone() {
      if (this.form.search.field == 'zone' && this.form.search.term != '') {
        if (this.form.list.length > 0) {
          const firstZone = this.form.list[0].attributes.zoneId;
          var i;
          for (i = 0; i < this.form.list.length; i++) {
            if (this.form.list[i].attributes.zoneId != firstZone) {
              return false;
            }
          }
          return true;
        }
      }
      return false;
    },
    sites() {
      return this.$store.getters.sites;
    },
    counties() {
      return this.$store.getters.counties;
    },
    routes() {
      return this.$store.getters.routes;
    },
    municipalities() {
      return this.$store.getters.municipalities;
    },
    habitats() {
      return this.$store.getters.habitats;
    },
    waters() {
      return this.$store.getters.waters;
    },
  },

  created() {
    this.onHideWithId = (id) => {
      if (this.$route.path.indexOf('larval') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-site-details',
          params: { id: this.$props.id },
        });
      }
    };
    window.bus.$on('item-created', this.onHideWithId);

    this.onHideNoId = () => {
      if (this.$route.path.indexOf('larval') > -1 && this.$props.id) {
        this.$router.push({
          name: 'data-site-details',
          params: { id: this.$props.id },
        });
      }
    };
    $(document).on('hide.bs.modal', this.onHideNoId);
  },

  mounted() {
    loader.lookups().then(() => {
      this.form.getList();
    });

    if (this.$props.id) {
      this.form.showEdit({});
      this.form.siteSearch.term = this.siteName(this.$props.id);
      this.form.onSiteSearch('siteId');
    }
  },

  destroyed() {
    $(document).off('hide.bs.modal', this.onHideNoId);
    $(document).off('hide.bs.modal', this.onHideWithId);
  },
};
</script>

<style lang="scss"></style>
